import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import reportService from "services/reportService";

// Thunk pour récupérer tous les signalements avec pagination et filtres
export const fetchReports = createAsyncThunk(
  "reports/fetchReports",
  async (params, { rejectWithValue }) => {
    try {
      const data = await reportService.fetchReports(params);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Unknown error");
    }
  }
);

// Thunk pour mettre à jour le statut d'un signalement
export const updateReportStatus = createAsyncThunk(
  "reports/updateReportStatus",
  async (params, { rejectWithValue }) => {
    try {
      const data = await reportService.updateReportStatus(params);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Unknown error");
    }
  }
);

const reportSlice = createSlice({
  name: "report",
  initialState: {
    reports: [],
    total: 0,
    totalPages: 0,
    currentPage: 1,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch Reports
      .addCase(fetchReports.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchReports.fulfilled, (state, action) => {
        state.loading = false;
        state.reports = action.payload.items;
        state.total = action.payload.totalItems;
        state.totalPages = action.payload.totalPages;
        state.currentPage = action.payload.currentPage;
      })
      .addCase(fetchReports.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Update Report Status
      .addCase(updateReportStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateReportStatus.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.reports.findIndex(
          (report) => report._id === action.payload._id
        );
        if (index !== -1) {
          state.reports[index] = action.payload;
        }
      })
      .addCase(updateReportStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default reportSlice.reducer;
